import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BulkListTypes } from '../../../stores/bulk.state';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { NgClass, NgForOf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { BadgeModule } from 'primeng/badge';
import { IndicatorDetailButtonComponent } from '../../atoms/indicator-detail-button/indicator-detail-button.component';
import { groupByType } from '../../../stores/data-layer/data-layer.selectors';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { DataLayerTypeIconComponent } from '../../atoms/data-layer-type-icon/data-layer-type-icon.component';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { ChipModule } from 'primeng/chip';
import { CategoryStore } from '../../../stores/category/category.state';

@Component({
  selector: 'app-bulk-overview-list',
  standalone: true,
  imports: [
    ScrollPanelModule,
    NgForOf,
    PanelModule,
    BadgeModule,
    IndicatorDetailButtonComponent,
    DataLayerTypeIconComponent,
    NgClass,
    ChipModule,
  ],
  templateUrl: './bulk-overview-list.component.html',
  styleUrl: './bulk-overview-list.component.scss',
})
export class BulkOverviewListComponent {
  readonly dataLayerTypeStore = inject(DataLayerTypeStore);
  readonly indicatorStore = inject(IndicatorStore);
  readonly categoryStore = inject(CategoryStore);
  readonly dataStore = inject(IndicatorDataStore);
  readonly dataLayerStore = inject(DataLayerStore);

  @Input() items: any[] = [];
  @Input() header = '';
  @Input() icon = '';
  @Input() labelProperty = 'name';
  @Input() listType!: BulkListTypes;
  @Output() details: EventEmitter<any> = new EventEmitter();

  showDetails(item: any) {
    this.details.emit(item);
  }

  getGroupedDataLayers() {
    return groupByType(this.items);
  }
}
